// extracted by mini-css-extract-plugin
export default {"cardBack":"_bcdcf600","hidden":"_656a99b5","closeButton":"_c1427adf","quickViewContent":"_b324137e","title":"_e28d395f","location":"_3edd9a62","summary":"_ce311db3"};